import Cookies from "js-cookie";
import { useMemo } from "react";

// Generic version of useIsAdmin.ts's own exact shape (parameterized instead of hardcoded to
// "admin"/"annotation_admin") - for gating a SECTION of an already-reachable page behind a
// standalone capability view, the way NewAdminPage.tsx gates its own admin-only tabs. Distinct
// from PrivateRoute.tsx's whole-ROUTE gating (accessControl.ts's evaluateNewAccessControl,
// keyed by location.pathname against DASHBOARD_REGISTRY/RESIDUAL_BUCKET_B_RULES) - a page can be
// reachable at all (e.g. /settings, which is in PUBLIC_AUTHENTICATED_PATHS and so ungated by any
// view) while still needing one of its own sections gated behind a specific view.
export const useHasView = (viewKey: string): boolean => {
  return useMemo(() => {
    const viewsCookie = Cookies.get("views");
    if (!viewsCookie) return false;
    try {
      const views: string[] = JSON.parse(viewsCookie);
      return views.includes(viewKey);
    } catch {
      return false;
    }
  }, [viewKey]);
};
